import { ErrorType } from './ErrorTypes';

export const CustomErrors = {};

CustomErrors[ErrorType.INACTIVE_ACCOUNT] = ErrorType.INACTIVE_ACCOUNT;
CustomErrors[ErrorType.Invalid_Cupis_V2_Verification] = ErrorType.Invalid_Cupis_V2_Verification;
CustomErrors[ErrorType.TWO_FACTOR_AUTH] = ErrorType.TWO_FACTOR_AUTH;
CustomErrors[ErrorType.AGENT_FIRST_LOGIN] = ErrorType.AGENT_FIRST_LOGIN;
CustomErrors[ErrorType.FIREBASE_NOT_REGISTERED] = ErrorType.FIREBASE_NOT_REGISTERED;

export default CustomErrors;